(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CancelarLiberacionController', CancelarLiberacionController);

    CancelarLiberacionController.$inject = ['$uibModalInstance', '$state', '$scope', 'entity', 'SSAsignacion'];

    function CancelarLiberacionController($uibModalInstance, $state, $scope, entity, SSAsignacion) {
        var vm = this;

        vm.sSAsignacion = entity;
		vm.motivo = '';
		
        vm.clear = clear;
        vm.confirmCancel = confirmCancel;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmCancel(id) {
            SSAsignacion.cancelarLiberacion({
				idAsignacion: id,
				'motivo': vm.motivo,
			}, onSaveSuccess, onSaveError);
        }
		
		function onSaveSuccess (result) {
			console.log(result)
		    $scope.$emit('serviciosocialApp:sSAsignacionUpdate', result);
		    $uibModalInstance.close(result);
		}
		        	
		function onSaveError () {
		}		
    }
})();
